import { useDragOperation, useDraggable } from "@dnd-kit/react";

import {
  ITEM_MOVE_DRAG_TYPE,
  isItemMoveDragData,
  type ItemMoveDragData,
} from "../item-move-dnd";
import type { Item } from "../types";

interface UseItemMoveDraggableOptions {
  item: Item;
  items: Item[];
  titles: string[];
  disabled?: boolean;
  onMoved?: () => void;
}

export function useItemMoveDraggable({
  item,
  items,
  titles,
  disabled = false,
  onMoved,
}: UseItemMoveDraggableOptions) {
  const { source } = useDragOperation();
  const draggable = useDraggable<ItemMoveDragData>({
    id: `${ITEM_MOVE_DRAG_TYPE}:${item.id}`,
    type: ITEM_MOVE_DRAG_TYPE,
    disabled,
    data: {
      kind: ITEM_MOVE_DRAG_TYPE,
      items: items.map(({ id, folder_id, format, tags }, index) => ({
        id,
        folder_id,
        format: format ?? "website",
        title: titles[index] ?? "未命名收藏",
        tagIds: tags?.map((tag) => tag.id) ?? [],
      })),
      onMoved,
    },
  });

  const isDragging = Boolean(
    source?.type === ITEM_MOVE_DRAG_TYPE &&
    isItemMoveDragData(source.data) &&
    source.data.items.some((draggedItem) => draggedItem.id === item.id),
  );

  return {
    ...draggable,
    isDragging,
  };
}
